import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import { fetchEngineHealth, fetchEngineMetrics } from '@/api/real/telemetry';

export function useCommandSnapshot() {
  return useQuery({
    queryKey: ['command', 'snapshot'],
    queryFn: api.getCommandSnapshot,
    staleTime: 20_000,
    refetchInterval: 60_000,
  });
}

/** Polls `GET /health` every 15 s. Resolves with `null` when no
 *  server is reachable (mock-mode dev / offline) — the panel renders
 *  that as a dimmed "offline" chip rather than an error. */
export function useEngineHealth() {
  return useQuery({
    queryKey: ['engine', 'health'],
    queryFn: fetchEngineHealth,
    staleTime: 10_000,
    refetchInterval: 15_000,
    retry: false,
  });
}

/** Polls `GET /metrics` every 30 s. `null` when unreachable. */
export function useEngineMetrics() {
  return useQuery({
    queryKey: ['engine', 'metrics'],
    queryFn: fetchEngineMetrics,
    staleTime: 20_000,
    refetchInterval: 30_000,
    retry: false,
  });
}
